module.exports = __webpack_public_path__ + "static/carbon-datepicker-range-selected-f8aa8421792b32c48f775a63c20bd48f.png";